import React, { useContext } from "react";
import style from "./index.module.scss";
import RollCallHeader from "./components/RollCallHeader";
import StuTable from "./components/StuTable";
import { paramsAtom } from "service/stores/RollCallStore";
import { CourseContext } from "../Store";
import RollModal from "./components/RollModal";
import { saveRandomCount } from "service/rollCall";
import WithProvider from "../../../components/WithProvider";
import { RouteComponentProps } from "react-router-dom";

function RollCall({}: RouteComponentProps) {
    const { course } = useContext(CourseContext);

    function handleClick() {
        return saveRandomCount(
            course.courseNo,
            course.courseSeq,
            course.weekTimeId
        );
    }

    return (
        <div className={style.root}>
            <RollCallHeader />
            <StuTable />
            <RollModal onhandleClick={handleClick} />
        </div>
    );
}

export default WithProvider(RollCall, () => {
    const { course } = useContext(CourseContext);

    const params = {
        weekTimeId: course.weekTimeId,
        courseNo: course.courseNo,
        courseSeq: course.courseSeq
    };

    return [[paramsAtom, params]];
});
